import { string, bool, shape, node, object } from "prop-types"
import { Link } from "@reach/router"
import moment from "moment"

import { css } from "@emotion/react"
import { size } from "@planningcenter/system"
import { colors } from "source/shared/colors"
import { Heading } from "@planningcenter/doxy-web"
import { useEmbedded } from "source/calendar/hooks/useEmbedded"

EventListing.propTypes = {
  eventId: string,
  eventDate: object,
  eventTitle: string,
  eventLocation: string,
  eventRecurrence: string,
  eventTime: string,
  signupsAvailable: bool,
}

export default function EventListing({
  eventId,
  eventDate,
  eventTitle,
  eventLocation,
  eventRecurrence,
  eventTime,
  signupsAvailable,
}) {
  const eventListing = css`
    color: ${colors.tint2};
    display: flex;
    justify-content: space-between;
    margin: 0 0 ${size(3)}px 0;
    width: 100%;
  `
  const eventListingTime = css`
    color: ${colors.tint2};
    text-align: right;
    white-space: nowrap;
  `
  const recurs = eventRecurrence && eventRecurrence != "Does not repeat"
  const eventDay = moment(eventDate).format("YYYY-MM-DD")
  return (
    <li css={eventListing} data-eventid={eventId} data-date={eventDay}>
      <div>
        <EventLink eventDay={eventDay} eventId={eventId}>
          <Heading color="brand" level={1} size={3} text={eventTitle} />
        </EventLink>
        {recurs && <div>{eventRecurrence}</div>}
        <div>{eventLocation}</div>
      </div>
      <div className="ml-2 ta-r">
        <div css={eventListingTime}>{eventTime}</div>
        {signupsAvailable && (
          <div className="success-badge badge">Signups available</div>
        )}
      </div>
    </li>
  )
}

EventLink.propTypes = {
  eventDay: string,
  eventId: string,
  children: node,
}
export function EventLink({ eventId, eventDay, children }) {
  const { embedded } = useEmbedded()
  const eventUrl = `calendar/event/${eventId}`
  return embedded ? (
    <a href={eventUrl} {...embedded && { target: "_blank" }}>
      {children}
    </a>
  ) : (
    <Link to={`event/${eventId}`} state={{ eventDate: eventDay }}>
      {children}
    </Link>
  )
}
